import { Model } from '../../_kernel/architecture'
import { z } from 'zod'
import { Money } from '../../_kernel/Money'

export const FeeValidation = z.object({
  total: z.instanceof(Money),
  local: z.instanceof(Money).optional(),
})

export class Fee extends Model {
  static create(total: Money, local?: Money) {
    FeeValidation.parse({ total, local })
    return new Fee(total, local)
  }

  static fromJSON({ total, local }: ReturnType<Fee['toJSON']>) {
    return Fee.create(Money.fromJSON(total), local ? Money.fromJSON(local) : undefined)
  }

  constructor(
    private readonly _total: Money,
    private readonly _local?: Money
  ) {
    super()
  }

  total() {
    return this._total
  }

  local() {
    return this._local
  }

  toJSON() {
    return {
      total: this._total.toJSON(),
      ...(this._local ? { local: this._local?.toJSON() } : {}),
    }
  }
}
